module.exports = __webpack_public_path__ + "static/media/travel.5c4a0cff.png";